// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  tinyMceApiKey: 'afv9tsj95eidodl8qy5jmp0znjmizgcwi33enkpfdt4nd6ox',

  // baseUrl: 'https://api.bediaprive.com',
  //baseUrl: 'http://localhost:8000',
  // baseUrl: 'https://api-bediaprive.adpedia.in',
  baseUrl: 'https://api.bediapottery.ae', // Live url
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
